import { render, staticRenderFns } from "./GoogleChat.vue?vue&type=template&id=19dad7be&"
import script from "./GoogleChat.vue?vue&type=script&lang=js&"
export * from "./GoogleChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports